<template>
    <div class="page-container">
        <div class="purchase-status-block">
            <div class="status-text">
                <!-- <div class="status">进货已完成</div>
                <div class="status-aside">您申请的进货商品已经成功添加至库存</div> -->

                <!-- <div class="status">待发货</div>
                <div class="status-aside">您的提货单待发货</div> -->

                <div class="status">进货待确认</div>
                <div class="status-aside">您的订单还没有确认,确认后才可增加库存</div>

                <!-- <div class="status">审核中</div>
                <div class="status-aside">您的进货单财务正在审核，入帐后您的库存即可更新</div> -->
            </div>
            <img src="../../assets/icon-purchase-succ.png" class="status-pic">
        </div>
        <div class="page-bottom">
            <div class="purchase-block">
                <div class="goods-bock" v-for="(item,index) in goodsList" :key="index">
                    <!-- 进货商品信息 -->
                    <div class="goods-info-block">
                        <img :src="item.picUrl" class="goods-pic">
                        <div class="goods-detail">
                            <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                            <div class="goods-sku">
                                <span>整箱(6瓶)</span>
                                <span style="color:#3088F5;">x{{item.num}}(箱)</span>
                            </div>
                            <div class="caigou-price">采购价：¥{{item.price}}/瓶</div>
                        </div>
                    </div>
                    <!-- 赠送商品信息 -->
                    <div class="presentation-block" v-for="(vitem,vindex) in item.goodsArr" :key="vindex">
                        <div class="present-left">
                            <div class="goods-pic">
                                <img :src="vitem.picUrl" alt="">
                                <img v-if="vitem.flag == 1" src="../../assets/tag-zs.png" alt="" class="tag">
                                <img v-else src="../../assets/tag-jl.png" alt="" class="tag">
                            </div>
                            <div class="goods-info">
                                <div class="goods-name">{{`${vitem.name} ${vitem.degree}度 ${vitem.capacity}`}}</div>
                                <div class="sku" style="color:#E43D3D;" v-if="vitem.remark">{{vitem.remark}}</div>
                            </div>
                        </div>
                        <div class="present-right">
                            <div class="present-right-wrapper">
                                x{{vitem.num}}(箱)
                            </div>
                        </div>
                    </div>
                    <!-- 该种酒总数 -->
                    <div class="goods-total">
                        <span class="total-num">总数：{{item.totalNum}}箱</span>
                        <span class="total-price">总价：￥{{item.amount}}</span>
                    </div>
                </div>
                <div class="info-block">
                    <div class="block-title">订单信息</div>
                    <div class="info-item">
                        <span>进货单号</span>
                        <span>{{pageData.orderNo}}</span>
                    </div>
                    <div class="info-item">
                        <span>进货时间</span>
                        <span>{{pageData.createTime | formatCreatetime}}</span>
                    </div>
                    <div class="info-item">
                        <span>进货总金额(元)</span>
                        <span>{{pageData.amount}}</span>
                    </div>
                    <div class="info-item">
                        <span>共申请进货(箱)</span>
                        <span>{{pageData.num}}</span>
                    </div>
                    <div class="info-item">
                        <span>共赠商品(箱)</span>
                        <span>{{pageData.sendNum}}</span>
                    </div>
                    <div class="info-item" v-if="pageData.saleNum != 0">
                        <span>进货可获销售奖(箱)</span>
                        <span>{{pageData.saleNum}}</span>
                    </div>
                    <!-- <div class="info-item">
                        <span>本次库存新增(箱)</span>
                        <span>{{pageData.totalNum}}</span>
                    </div> -->
                </div>
            </div>
            <!-- <div class="see-account" @click="showLayer = true">查看对公账户</div> -->
        </div>
        <!-- <div class="btn-confirm">确认进货</div> -->

        <!-- 对公弹层 -->
        <!-- <van-popup v-model="showLayer" round closeable close-icon="close" position="bottom">
            <div class="layer-wrapper">
                <div class="layer-title">请往下方公户转账</div>
                <div class="account-block">
                    <div class="account-item">
                        <span class="account-title">账户名称</span>
                        <span class="account-content">{{accountInfo.name}}</span>
                        <span class="btn-copy" v-clipboard:copy="accountInfo.name" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span>
                    </div>
                    <div class="account-item">
                        <span class="account-title">开户行</span>
                        <span class="account-content">{{accountInfo.bankName}}</span>
                        <span class="btn-copy" v-clipboard:copy="accountInfo.bankName" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span>
                    </div>
                    <div class="account-item">
                        <span class="account-title">对公账户号</span>
                        <span class="account-content">{{accountInfo.account}}</span>
                        <span class="btn-copy" v-clipboard:copy="accountInfo.account" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span>
                    </div>
                </div>
                <div class="layer-notice">
                    <div class="notice-title">温馨提示</div>
                    <div class="notice-content">请核准账户信息，转账后财务讲进行核实，审核通过即新增库存数据</div>
                </div>
            </div>
        </van-popup> -->

        <!-- 输入密码弹层 -->
        <van-overlay :show="showPasswordLayer">
            <div class="wrapper">
                <div class="layer-content-block" :class="{'wrapper-to-top':showKeyboard}">
                    <div class="content-title">请输入交易密码 <van-icon name="cross" class="btn-close" size="22" color="#d2d2d2" @click.stop="showPasswordLayer = false" /></div>
                    <div class="content-bottom">
                        <div class="pay-detial">进货金额</div>
                        <div class="price">
                            ¥ <span>{{pageData.amount}}</span>
                        </div>
                        <div class="account-info"><span>付款账户</span><span>御粮账户</span></div>
                        <!-- 密码输入框 -->
                        <van-password-input
                        :value="password"
                        :focused="showKeyboard"
                        @focus="showKeyboard = true"
                        />
                        <div class="err-notice" v-show="passwordErrorMsg">{{passwordErrorMsg}}</div>
                        <div class="layer-btn-confirm" @click="confirm">确认进货</div>
                    </div>
                </div>
            </div>
        </van-overlay>
        <!-- 数字键盘 -->
        <van-number-keyboard
        v-model="password"
        :show="showKeyboard"
        @blur="showKeyboard = false"
        />
        <div class="btn-confirm" @click="confirm">确认进货</div>
    </div>
</template>

<script>
import { Popup,Notify,Overlay,Icon,PasswordInput,NumberKeyboard,Toast } from 'vant'

import $http from '@/lib/request'
import config from '@/config'
import md5 from 'js-md5'

export default {
    data(){
        return{
            // showLayer:false,
            // accountInfo:{
            //     name:'白家酒业有限公司',
            //     bankName:'交通银行北京市海淀区苏州街支行',
            //     account:'129581925801258120'
            // }
            showPasswordLayer:false,
            password:'',
            showKeyboard:false,
            oid:'',//orderid
            pageData:{},//页面数据
            goodsList:[],//商品列表
            passwordErrorMsg:'',//密码错误提示信息
        }
    },
    watch:{
        showPasswordLayer(val,oldVal){
            this.password='';
        }
    },
    activated(){
        this.oid=this.$route.params.oid;
        $http({
            method:'post',
            data:{
                orderId:this.oid,
            },
            url:config.api.getPickupConfirmInfo
        }).then(res=>{
            if(res.errno == 0){
                this.pageData=res.data;
                this.goodsList=res.data.goodsList;
            }else{
                Toast(res.errmsg);
            }
        })
    },
    deactivated(){
        this.password='';
        this.showPasswordLayer=false;
        this.showKeyboard=false;
    },
    components:{
        // [Popup.name]:Popup,
        // [Notify.name]:Notify
        [Overlay.name]:Overlay,
        [Icon.name]:Icon,
        [PasswordInput.name]:PasswordInput,
        [NumberKeyboard.name]:NumberKeyboard,
        [Toast.name]:Toast
    },
    methods:{
        copySucc(){
            Notify({ type: 'success', message: '复制成功' });
        },
        copyFail(){
            Notify({ type: 'danger', message: '复制失败' });
        },
        confirm(){
            
            this.$router.push({
                name:'common-yzm',
                params:{
                    orderId:this.oid,
                    amount:this.pageData.amount,
                    action:'jinhuo'
                }
            });
                
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .van-password-input{
    margin:0
}
@mixin flex-beteween{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.wrapper-to-top{
    transform: translateY(-40%);
}
.layer-content-block {
    background-color: #fff;
    width:300px;
    border-radius: 8px;
    .content-title{
        height:50px;
        line-height: 50px;
        text-align: center;
        position: relative;
        color:#333;
        font-size: 18px;
        .btn-close{
            position: absolute;
            right:15px;
            top:50%;
            transform: translateY(-50%);
        }
    }
    .content-bottom{
        padding:20px 28px;
        .pay-detial{
            font-size: 13px;
            color:#333;
            line-height: 18px;
            text-align: center;
            margin-bottom: 5px;
        }
        .price{
            text-align: center;
            color:#333;
            font-size: 26px;
            font-weight: 500;
            font-family: PingFangSC-Medium, PingFang SC;
            margin-bottom: 20px;
            &>span{
                font-size: 36px;
            }
        }
        .account-info{
            border-top:1px solid #f0f0f0;
            padding-top: 15px;
            line-height: 18px;
            margin-bottom: 25px;
            @include flex-beteween();
            &>span{
                font-size: 13px;
                color:#333;
                &:last-child{
                    font-weight: 500;
                }
            }
        }
        .err-notice{
            margin-top: 10px;
            color:#E43D3D;
            font-size: 13px;
            line-height: 18px;
        }
        .layer-btn-confirm{
            height:40px;
            line-height: 40px;
            text-align: center;
            border-radius: 26px;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            color:#fff;
            font-size: 16px;
            margin-top: 25px;
        }
    }
}
.page-container{
    min-height:calc(100vh - 46px);
    background:#f5f5f5;
    box-sizing: border-box;
    padding-bottom: 66px;
    .purchase-status-block{
        padding:20px 36px;
        background: linear-gradient(110deg, #3CA7FE 0%, #3088F5 100%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .status-text{
            width:230px;
            color:#fff;
            .status{
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 4px;
            }
            .status-aside{
                font-size: 12px;
                line-height: 16px;
            }
        }
        .status-pic{
            width:60px;
            height:60px;
        }
    }
    .page-bottom{
        padding:10px;
        .purchase-block{
            position: relative;
            .goods-bock{
                background:#fff;
                border-radius: 4px;
                padding:15px;
                box-sizing: border-box;
                margin-bottom: 10px;
                position: relative;
                &::after,&::before{
                    content:'';
                    display: block;
                    width:20px;
                    height:20px;
                    border-radius: 50%;
                    background:#f5f5f5;
                    position: absolute;
                    top:102px;
                }
                &::before{
                    left:-10px;
                }
                &::after{
                    right:-10px;
                }
                .goods-info-block{
                    display: flex;
                    justify-content: flex-start;
                    .goods-pic{
                        width:80px;
                        height:80px;
                        margin-right: 10px;
                        border-radius: 4px;
                    }
                    .goods-detail{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        width:calc(100% - 70px);
                        .goods-name{
                            overflow: hidden;
                            text-overflow:ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            color:#000;
                            line-height: 20px;
                            font-size: 14px;
                        }
                        .goods-sku{
                            @include flex-beteween();
                            color:#999;
                            line-height: 18px;
                            font-size: 12px;
                        }
                        .caigou-price{
                            color:#999;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
                .presentation-block{
                    position: relative;
                    margin-top: 30px;
                    @include flex-beteween();
                    .present-left{
                        width:280px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        .goods-pic{
                            width:50px;
                            height:50px;
                            border-radius: 4px;
                            overflow: hidden;
                            position: relative;
                            margin-right: 10px;
                            &>img{
                                display: block;
                                width:100%;
                                height:100%;
                            }
                            .tag{
                                position: absolute;
                                top:0;
                                left:0;
                                width:24px;
                                height:14px;
                            }
                        }
                        .goods-info{
                            width:220px;
                            height:50px;
                            display: flex;
                            justify-content: space-between;
                            flex-direction: column;
                            .goods-name{
                                font-size: 12px;
                                color:#000;
                                line-height: 18px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .sku{
                                color:#999;
                                font-size: 10px;
                                line-height: 14px;
                            }
                        }
                    }
                    .present-right{
                        width:71px;
                        height:54px;
                        font-size: 12px;
                        color: #999;
                        background:url('../../assets/count-box.png') no-repeat center center;
                        background-size: 71px 54px;
                        display: flex;
                        align-items: center;
                        .present-right-wrapper{
                            width:60px;
                            text-indent: 11px;
                            text-align: center;
                            color:#3088F5;
                        }
                    }
                }
                .goods-total{
                    font-size: 14px;
                    color:#999;
                    text-align: right;
                    margin-top: 15px;
                    .total-num{
                        margin-right: 10px;
                    }
                    .total-price{
                        color:#333;
                    }
                }
            }
            .info-block{
                padding:15px;
                background:#fff;
                border-radius: 4px;
                .block-title{
                    font-size: 14px;
                    color:#333;
                    padding-bottom:15px;
                }
                .info-item{
                    color:#666;
                    line-height: 18px;
                    padding:4px 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 13px;
                    &>span{
                        &:last-child{
                            text-align: right;
                            color:#333;
                        }
                    }
                }
            }
        }
        .see-account{
            color:#000;
            font-size: 16px;
            line-height: 22px;
            margin-top: 25px;
        }
    }
    .btn-confirm{
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        font-size: 14px;
        color:#fff;
        position: fixed;
        bottom:20px;
        left:50%;
        transform: translateX(-50%);
        @media screen and (max-width:750px){
            border-radius: 26px;
        }
    }
    .layer-wrapper{
        padding:20px;
        padding-bottom: 0;
        .layer-title{
            font-weight: 500;
            color:#333;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
        }
        .account-block{
            padding-top: 25px;
            .account-item{
                margin-bottom: 12px;
                color:#333;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                font-size: 14px;
                .account-title{
                    width:80px;
                    margin-right: 6px;
                }
                .account-content{
                    max-width:210px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    margin-right: 6px;
                }
                .btn-copy{
                    color:#3088F5;
                }
            }
        }
        .layer-notice{
            margin-top: 20px;
            padding-bottom: 50px;
            .notice-title{
                color:#3088F5;
                line-height: 18px;
                margin-bottom: 6px;
                font-size: 14px;
            }
            .notice-content{
                color:#999;
                line-height: 16px;
                font-size: 12px;
            }
        }
    }
}
</style>